function SVGTitle() {
  return (
    <svg
      viewBox="0 0 200 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "140px", marginTop: "-50px" }}
    >
      <defs>
        <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#2BA3DF" />
          <stop offset="100%" stopColor="#6dd5ed" />
        </linearGradient>
      </defs>
      <path
        d="M10,40 Q50,90 190,30"
        stroke="url(#lineGradient)"
        strokeWidth="8"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SVGTitle;
